import { AppLanguage, getPreferredLanguage } from '../language';
import { orderStatusTemplate } from './order/orderStatus';
import { OrderI18nTemplate } from './order/orderTypes';
import { orderUiHistoryTemplate } from './order/orderUiHistory';
import { orderUiHistoryDetailTemplate } from './order/orderUiHistoryDetail';
import { orderUiSharedTemplate } from './order/orderUiShared';

export type { OrderI18nTemplate } from './order/orderTypes';

export const TEMPLATES: Record<AppLanguage, OrderI18nTemplate> = {
  zh: {
    status: orderStatusTemplate.zh,
    ui: {
      ...orderUiSharedTemplate.zh,
      history: orderUiHistoryTemplate.zh,
      historyDetail: orderUiHistoryDetailTemplate.zh,
    },
  },
  en: {
    status: orderStatusTemplate.en,
    ui: {
      ...orderUiSharedTemplate.en,
      history: orderUiHistoryTemplate.en,
      historyDetail: orderUiHistoryDetailTemplate.en,
    },
  },
};

export const ORDER_NAMESPACE = 'order';

export const ORDER_RESOURCE_KEY = 'template';

export const ORDER_I18N_RESOURCES: Record<
  AppLanguage,
  Record<typeof ORDER_RESOURCE_KEY, OrderI18nTemplate>
> = {
  zh: {
    [ORDER_RESOURCE_KEY]: TEMPLATES.zh,
  },
  en: {
    [ORDER_RESOURCE_KEY]: TEMPLATES.en,
  },
};

export const getOrderTemplate = (
  language: AppLanguage = getPreferredLanguage(),
): OrderI18nTemplate => TEMPLATES[language] || TEMPLATES.zh;

export const txByLanguage = (
  language: AppLanguage,
  zh: string,
  en: string,
): string => (language === 'en' ? en : zh);

export const getLocalizedStatusMessage = (
  status: string,
  language: AppLanguage,
): string => {
  const template = getOrderTemplate(language);
  const mapping = template.status.order[status] || template.status.label[status];
  return mapping || status;
};

export const getOrderUiTemplate = (language: AppLanguage) =>
  getOrderTemplate(language).ui;
